import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconSlightCurveUp = function IconSlightCurveUp(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 10.416C13.9524 10.5692 14.2628 10.5071 14.416 10.2774C14.5692 10.0476 14.5071 9.73715 14.2774 9.58397L13.7226 10.416ZM1.72265 9.58397C1.49289 9.73715 1.4308 10.0476 1.58397 10.2773C1.73715 10.5071 2.04759 10.5692 2.27735 10.416L1.72265 9.58397ZM14.2774 9.58397C10.4761 7.0498 5.52391 7.0498 1.72265 9.58397L2.27735 10.416C5.74271 8.10579 10.2573 8.10579 13.7226 10.416L14.2774 9.58397Z",
    fill: "black"
  }));
};

export { IconSlightCurveUp };